module.exports = __webpack_public_path__ + "static/media/video_3.bf957be3.mp4";